import Vue from 'vue'
import axios from 'axios'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || ''
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
const config = {
  baseURL: process.env.baseURL || process.env.apiUrl || '',
  timeout: 10 * 1000, // Timeout
  withCredentials: false, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // console.log(config)
    // if(config.headers['Content-Type'] == 'multipart/form-data') {
    //   config.data.set('token', token)
    //   return config
    // }
    // if(config.method == 'post') {
    //   config.params = {'token': token}
    //   config.headers['Content-Type'] = 'multipart/form-data'
    //   // config.headers['token'] = token
    // } else if(config.method == 'get') {
    //   config.params.token = token
    // }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error)
  }
)

const Axios = {
  install:  (Vue) => {
    // window.axios = _axios
    Vue.axios = _axios
    Vue.prototype.$axios = _axios
  }
}

Vue.use(Axios)

export default Axios
